export class ImagePreviewDialog {
  ImageURL: string;
  Sign?: boolean;
}
